module.exports = __webpack_public_path__ + "assets/img/CompanyNews_bgimg.e83c1b46.png";